import React from 'react';
import PhotoUpload from '../common/PhotoUpload';

const CheckoutForm = ({ formData, employees = [], sites = [], onChange, onAddPerson, photos = [], onPhotosChange, photosMandatory = false, photosDisabled = false }) => {
  return (
    <div className="checkout-form">
      <h2 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: 600 }}>Assignment Details</h2>

      <div className="form-group">
        <label htmlFor="checkoutDate">Check-Out Date *</label>
        <input
          id="checkoutDate"
          type="date"
          name="checkoutDate"
          value={formData.checkoutDate}
          onChange={onChange}
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="checkoutTo">Check-Out To *</label>
        <div style={{ display: 'flex', gap: '12px', marginBottom: '8px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
            <input
              type="radio"
              name="checkoutTo"
              value="person"
              checked={formData.checkoutTo === 'person'}
              onChange={onChange}
            />
            <span style={{ fontSize: '13px' }}>Person</span>
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
            <input
              type="radio"
              name="checkoutTo"
              value="site"
              checked={formData.checkoutTo === 'site'}
              onChange={onChange}
            />
            <span style={{ fontSize: '13px' }}>Site</span>
          </label>
        </div>
      </div>

      {formData.checkoutTo === 'person' && (
        <div className="form-group">
          <label htmlFor="assignedTo">Assign To (Employee or Admin) *</label>
          <div style={{ display: 'flex', gap: '8px' }}>
            <select
              id="assignedTo"
              name="assignedTo"
              value={formData.assignedTo}
              onChange={onChange}
              required
              style={{ flex: 1 }}
            >
              <option value="">Select Employee or Admin</option>
              {employees.map(emp => (
                <option key={emp.id || emp._id} value={emp.id || emp._id}>
                  {emp.name} {emp.role === 'admin' ? '[Admin]' : ''} {emp.email ? `(${emp.email})` : ''}
                </option>
              ))}
            </select>
            <button
              type="button"
              onClick={onAddPerson}
              style={{
                padding: '10px 12px',
                background: '#f7fafc',
                border: '1px solid #e2e8f0',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '12px',
                fontWeight: 500,
                whiteSpace: 'nowrap'
              }}
            >
              + New
            </button>
          </div>
        </div>
      )}

      {formData.checkoutTo === 'site' && (
        <div className="form-group">
          <label htmlFor="site">Select Site *</label>
          <select
            id="site"
            name="site"
            value={formData.site}
            onChange={onChange}
            required
          >
            <option value="">Select Site</option>
            {sites.map(site => (
              <option key={site.id || site._id} value={site.id || site._id}>
                {site.name}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="form-group">
        <label htmlFor="dueDate">Due Date</label>
        <input
          id="dueDate"
          type="date"
          name="dueDate"
          value={formData.dueDate}
          onChange={onChange}
          min={formData.checkoutDate}
        />
        <small style={{ color: '#718096', fontSize: '11px', marginTop: '4px', display: 'block' }}>
          Optional - Expected return date
        </small>
      </div>

      <div className="form-group">
        <PhotoUpload
          photos={photos}
          onPhotosChange={onPhotosChange}
          mandatory={photosMandatory}
          label="Checkout Photos"
          disabled={photosDisabled}
        />
      </div>
    </div>
  );
};

export default CheckoutForm;
